<template>
	<div>
		<el-link type="primary" v-if="fileList.length == 1" @click="downloadFile(fileList[0])">{{fileList[0].documentName}}</el-link>
		<el-link v-if="canEdit && fileList.length == 1" @click="delFile(fileList[0],0)" type="danger" style="padding-left: 1em" size="mini">X</el-link>
		<el-dropdown v-if="fileList.length > 1">
			<span class="el-dropdown-link">
				文件列表({{fileList.length}})<i class="el-icon-arrow-down el-icon--right"></i>
			</span>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item v-for="(file,index) in fileList">
					<el-link type="primary" @click="downloadFile(file)">{{file.documentName}}</el-link>
					<el-link v-if="canEdit" @click="delFile(file,index)" type="danger" style="padding-left: 1em" size="mini">X</el-link>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
	</div>
</template>
<script>
	import {fileService} from '@/api/common/file-utils'
	import commonFun from "@/utils/commonFun";

	export default{
		props:["files","canEdit"],
		data: function () {
			return {
				fileList: commonFun.convertToArray(this.files),
				fileListDialog: false
			}
		},
		watch: {
			files(newVal){
				this.fileList =  commonFun.convertToArray(newVal);
			}
		},
		methods:{
			downloadFile(doc) {
				fileService.downloadFile(doc);
			},
			delFile(file, index) {
				let that = this;
				if (commonFun.isNotEmpty(file.tmDocumentId)) {
					fileService.deleteFile(file.tmDocumentId).then(value => {
						that.fileList.splice(index, 1);
					});
				} else {
					that.fileList.splice(index, 1);
				}
			}
		}
	}
</script>
